import Store from 'beedle';
import { get, post } from './requests';

let _saveUrl;
let _onPost;
let _onLoad;

const countFormFields = (data) => {
	return data ? data.length : 0;
};

const store = new Store({
	actions: {
		setData(context, data, saveData) {
			const fieldCount = countFormFields(data);
			const fieldLimit = context.state.fieldLimit;
			context.commit('setData', data);
			context.commit('setFieldCount', fieldCount);
			context.commit('setFieldLimitReached', fieldLimit ? fieldCount >= fieldLimit : false);
			if (saveData) this.save(data);
		},

		load(context, { loadUrl, saveUrl, data, saveAlways, fieldLimit }) {
			_saveUrl = saveUrl;
			const saveA = saveAlways || saveAlways === undefined;
			context.commit('setSaveAlways', saveA);
			context.commit('setFieldLimit', fieldLimit || null);

			if (_onLoad) {
				_onLoad().then((x) => {
					if (data && data.length > 0 && x.length === 0) {
						data.forEach((y) => x.push(y));
					}
					this.setData(context, x);
				});
			} else if (loadUrl) {
				get(loadUrl).then((x) => {
					if (data && data.length > 0 && x.length === 0) {
						data.forEach((y) => x.push(y));
					}
					this.setData(context, x);
				});
			} else {
				this.setData(context, data);
			}
		},

		create(context, element) {
			const { data, saveAlways, fieldLimitReached, fieldLimit } = context.state;

			if (fieldLimit && fieldLimitReached) {
				return;
			}

			data.push(element);
			this.setData(context, data, saveAlways);
		},

		setFieldLimit(context, fieldLimit) {
			context.commit('setFieldLimit', fieldLimit);
			if (fieldLimit) {
				const fieldCount = countFormFields(context.state.data);
				context.commit('setFieldLimitReached', fieldCount >= fieldLimit);
			} else {
				context.commit('setFieldLimitReached', false);
			}
		},

		deletePlaceholders(context, element) {
			const { data, saveAlways } = context.state;
			data.forEach((e, index) => {
				if (e.element === 'CardPlaceHolder') {
					data.splice(index, 1);
				}
			});
			this.setData(context, data, saveAlways);
		},

		delete(context, element) {
			const { data, saveAlways } = context.state;
			data.splice(data.indexOf(element), 1);
			this.setData(context, data, saveAlways);
		},

		post(context) {
			const { data } = context.state;
			this.setData(context, data, true);
		},

		updateOrder(context, elements) {
			const { saveAlways } = context.state;
			const newData = elements.filter((x) => x && !x.parent_id);
			elements.filter((x) => x && x.parent_id).forEach((x) => newData.push(x));
			this.setData(context, newData, saveAlways);
		},

		save(data) {
			if (_onPost) {
				_onPost({ task_data: data });
			} else if (_saveUrl) {
				post(_saveUrl, { task_data: data });
			}
		}
	},

	mutations: {
		setData(state, payload) {
			// eslint-disable-next-line no-param-reassign
			state.data = payload;
			return state;
		},
		setSaveAlways(state, payload) {
			// eslint-disable-next-line no-param-reassign
			state.saveAlways = payload;
			return state;
		},
		setFieldCount(state, payload) {
			// eslint-disable-next-line no-param-reassign
			state.fieldCount = payload;
			return state;
		},
		setFieldLimit(state, payload) {
			// eslint-disable-next-line no-param-reassign
			state.fieldLimit = payload;
			return state;
		},
		setFieldLimitReached(state, payload) {
			// eslint-disable-next-line no-param-reassign
			state.fieldLimitReached = payload;
			return state;
		}
	},

	initialState: {
		data: [],
		saveAlways: true,
		fieldCount: 0,
		fieldLimitReached: false,
		fieldLimit: null
	}
});

store.setExternalHandler = (onLoad, onPost) => {
	_onLoad = onLoad;
	_onPost = onPost;
};

store.getFieldLimitInfo = () => ({
	limit: store.state.fieldLimit,
	current: store.state.fieldCount,
	remaining: store.state.fieldLimit
		? Math.max(0, store.state.fieldLimit - store.state.fieldCount)
		: null,
	isLimitReached: store.state.fieldLimitReached
});

export default store;
